import React, { HTMLAttributes } from 'react'
import styled from 'styled-components'

interface ButtonDeleteAllProps extends HTMLAttributes<HTMLButtonElement> {}

const ButtonDeleteAll: React.FC<ButtonDeleteAllProps> = (props) => {
  return <StyledButtonDeleteAll {...props} />
}

const StyledButtonDeleteAll = styled.button`
  background-color: transparent;
  color: #a8aeb3;
  font-weight: 500;
  font-size: 14px;
  border: 0px;
  cursor: pointer;
`
export default ButtonDeleteAll
